import React from "react";
import "./AstroVastu.css";
import vastuBanner from "../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../components/BlogSlider";
import ServiceProduts from "../components/ServiceProduts";
import ContactForm from "../components/ContactForm"; 

const WealthAstrology = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       


         <h2>Wealth Astrology</h2>
    
    <p>People have immense faith and trust in Wealth astrology. All the people wish for prosperity, peace and happiness in life and in order to be wealthy and ever blessed, they propitiate Goddess Lakshmi, Lord Ganesh and Goddess Saraswathi.</p>
    
    <p>Wealth astrology or the money horoscope or horoscope wealth can be predicted by astrologers by analyzing the wealth house in astrology by critically examining the birth charts.</p>
    
    <p>The particular houses in the horoscopes are examined in relation to the celestial positioning of the planet and stars and, thereafter, astrologers predict about the prospects of wealth, happiness and prosperity in one’s life.</p>
    
    <p>Parents and Guardians tend to avail the services of astrologers with regard to career and money horoscope by date of birth for their wards.</p>
    
    <p>In the present times, when there is immense competition in all the spheres, people tend to take consultation with renowned Astrologers in respect of career and money horoscope by date of birth.</p>
    
    <p>They tend to derive optimum advantage of the cosmic energies by taking appropriate measures to propitiate and appease the influential celestial planets.</p>
    
    <h2>Wealth House in Astrology</h2>
    
    <p>From the perspective of Money horoscope or the horoscope wealth, the 2nd and 11th houses in horoscope, reflect upon the signs you will be rich astrology. The second house is considered as the wealth house in astrology.</p>
    
    <p>Second house gives the clue about one’s personal financial conditions, resources for wealth generation and attitudes towards spending or saving money.</p>
    
    <p>Likewise, eleventh house in the money horoscope throws light about the prospects for social networking and investment opportunities. House of wealth in astrology indicates the about the prospects of wealth generation, and outflow of money.</p>
    
    <p>It is often said that Lakshmi is very chanchal or restless or lively. Money needs to be spent wisely for the sake of ensuring sustainable growth and development.</p>
    
    <p>Education plays a pivotal role in ethical wealth generation and spending money in a mindful manner. Wealth astrology takes into all the financial aspects including the benevolent aspect and the tendency for working for social causes.</p>
    
    <p>Those who are blessed by the grace of the celestial planets or cosmic energies, do spend a lot for the social good for a public cause.</p>
    
    <p>Wealth astrology covers myriad of aspects. Albeit it is the is the domain of Chartered accountants and other financial experts to look for the flow charts or money trails yet it is the Astrologers who predict money astrology by date of birth or the career and money horoscope by date of birth by critically analysing the signs you will be rich astrology.</p>
    
    <h2>Influential planet of money in astrology or the influential planet of wealth in astrology</h2>
    
    <p>As per wealth astrology or the wealth house in astrology or the money in astrology, there are certain influential planets that determine the prospects of opportunities of wealth generation and career advancement.</p>
    
    <p>Horoscope Wealth indicates about the growth in business or the probability of incurring loss or profit, based on the celestial movements of the planets vis-a-vis the planetary positioning in the horoscopes or the natal charts.</p>
    
    <p>The planets that have significant influence on the wealth astrology include the following:-</p>
    
    <p>Jupiter or the Brihaspati: Jupiter is known to be the largest planet of our solar system. It is associated with wealth astrology, symbolizing expansion, abundance, good fortune in terms of creating a plethora of opportunities for financial growth and development.</p>
    
    <p>Venus or the Shukra Griha: Venus or the Shukra Griha is associated with beauty, pleasure and luxurious style of living. It is considered as a planet of money in astrology, influencing material possessions and financial stability. Strong Venus is indicative of generation of wealth through creative and artistic pursuits.</p>
    
    <p>Mercury or the Budh Griha: Mercury or the Budh Griha is believed to be associated with expertise in communication skills, trade and commerce. Mercury is also considered as planet of money in astrology that is known to sharpen business acumen and quick decision making abilities.</p>
    
    <p>Sun: The Sun is the ruling planet of Leos. The Sun symbolizes vitality, creativity, and self-expression. Leos, influenced by their ruling planet, are often characterized by confidence and tend to have natural inclination to be the center of attraction. The Sun is believed to influence the career and money horoscope by date of birth. Thus, the Sun plays a pivotal role in wealth astrology by affording opportunities for career progression.</p>
    
    <p>Moon: The moon is believed to be associated with money horoscope. It is believed that it governs emotions and intuitive capabilities and is also known to influence one’s approach towards financial dealings. It is believed to establish overall financial stability in wealth astrology.</p>
    
    <h2>Favourable conjunctions in Wealth Astrology</h2>
    
    <p>Dhan Yoga in Vedic astrology, refers to auspicious planetary combinations in a birth chart that signify wealth, prosperity, and financial success. It highlights the prospects of money astrology by date of birth.</p>
    
    <p>Dhan Yog is the wealth house in astrology which means alignment of celestial planets and stars across the various houses in the natal chart that predict creation of wealth or the money astrology by date of birth.</p>
    
    <p>The term "Dhan" means wealth, and "Yog" refers to favorable alignment of the celestial planets.</p>
    
    <h2>Celestial Dhan Yog formation</h2>
    
    <p>Celestial Dhan Yoga formation takes place when the planets and stars favourably align in sync in horoscopes.</p>
    
    <p>The houses that matter in Dhan yog include- the 2nd house representing accumulation of wealth; the 5th house representing creativity and generation of wealth through speculation; the 9th house representing unexpected or sudden gains; and the 11th house representing the flow of wealth.</p>
    
    <p>Gaj Kesari Yog: Gaj Kesari Yog is the wealth house in astrology where Jupiter’s alignment with Moon is indicative of prosperity and abundance of wealth.</p>
    
    <p>Lakshmi Yog: Wealth house in astrology is also indicated by the formation of Lakshmi Yog which is formed when the planet Venus or the Shukra Griha is strong and aligns with other planets, symbolising luxurious life-style and bestowing abundance of wealth.</p>
    
    <p>For money in astrology, the astrologers recommend chanting of Mantras especially to appease and propitiate the celestial planets like Jupiter or the Brihaspati or Guru and the Venus, the Shukra Griha.</p>
    
    <p>Astrologers also recommend wearing of certain types of Gemstones e.g. Yellow sapphire for propitiating Jupiter.</p>
    
    <p>Also, in order to strengthen benefic aspects of certain planets in particular houses, the astrologers recommend for giving donations and alms to poor. They also sometimes recommend performance of certain Puja rituals.</p>
    
    <h2>Relevance of Karma in wealth and astrology</h2>
    
    <div class="sanskrit">
       <p>कर्मण्येवाधिकारस्ते मा फलेषु कदाचन।</p> 
        
        <p>मा कर्मफलहेतुर्भूर्मा ते सङ्गोऽस्त्वकर्मणि॥</p>
    </div>
    
    <p>Apart from the celestial aspects regarding wealth and astrology, in Bhagwad Gita, Chapter 2, Verse 47, Lord Krishna tells Arjuna about the relevance of Karma as follows-</p>
        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

        <ContactForm />

       
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default WealthAstrology;
